var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoPushFusion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 500 381",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.805,93.123c-8.497,8.566 -14.805,19.304 -18.017,31.308c-0.378,1.436 -1.33,5.382 -1.27,8.443c0.068,3.507 0.039,6.633 -0.01,8.94c0.007,0.283 0.01,0.566 0.01,0.851c0,1.079 -0.047,2.148 -0.14,3.206l0,0.001c-0.767,8.73 -4.629,16.577 -10.481,22.436l-0.008,0.018l-0.005,-0.005l-0.545,0.533c-0.497,0.478 -1.008,0.941 -1.533,1.39l-0.716,0.597c-0.142,0.115 -0.285,0.23 -0.429,0.344c-0.738,0.581 -1.499,1.135 -2.281,1.658l-0.133,0.088c-3.129,2.076 -6.599,3.679 -10.305,4.707c-0.144,0.04 -0.288,0.079 -0.433,0.118l-0.981,0.244l-0.659,0.148c-0.35,0.075 -0.702,0.145 -1.055,0.21c-0.056,0.01 -0.111,0.02 -0.166,0.03c-2.046,0.366 -4.153,0.561 -6.304,0.567l-0.117,0.001c-10.015,0 -19.087,-4.066 -25.656,-10.635c-6.569,-6.569 -10.635,-15.642 -10.635,-25.656l0,-0.118c0.007,-2.15 0.201,-4.257 0.567,-6.303c0.01,-0.055 0.02,-0.11 0.031,-0.166c0.064,-0.353 0.134,-0.705 0.21,-1.055l0.148,-0.66l0.244,-0.981c0.038,-0.144 0.077,-0.288 0.117,-0.432c1.029,-3.707 2.632,-7.176 4.707,-10.305l0.089,-0.133c0.523,-0.782 1.077,-1.543 1.658,-2.281c0.114,-0.144 0.228,-0.287 0.344,-0.43l0.597,-0.716c0.449,-0.524 0.912,-1.035 1.389,-1.532l0.534,-0.545l-0.005,-0.005l0.018,-0.009c5.859,-5.851 13.706,-9.714 22.436,-10.48l0.001,0c1.058,-0.093 2.127,-0.14 3.206,-0.14c0.285,0 0.568,0.003 0.851,0.01c2.307,-0.049 5.433,-0.079 8.939,-0.01c3.062,0.059 7.008,-0.892 8.444,-1.27c12.098,-3.237 22.911,-9.619 31.51,-18.218c8.599,-8.6 14.981,-19.412 18.219,-31.51c0.377,-1.437 1.329,-5.382 1.269,-8.444c-0.068,-3.506 -0.039,-6.633 0.01,-8.94c-0.007,-0.282 -0.01,-0.566 -0.01,-0.85c0,-1.08 0.047,-2.149 0.14,-3.206l0,-0.001c0.767,-8.73 4.629,-16.578 10.481,-22.436l0.008,-0.019l0.006,0.005l0.544,-0.533c0.497,-0.477 1.009,-0.94 1.533,-1.389l0.716,-0.597c0.142,-0.116 0.285,-0.231 0.43,-0.344c0.738,-0.582 1.499,-1.135 2.281,-1.659l0.132,-0.088c3.13,-2.075 6.599,-3.678 10.305,-4.707c0.144,-0.04 0.288,-0.079 0.433,-0.117l0.981,-0.245l0.659,-0.148c0.35,-0.075 0.702,-0.145 1.056,-0.21c0.055,-0.01 0.11,-0.02 0.165,-0.03c2.046,-0.366 4.153,-0.56 6.304,-0.567l0.117,0c10.015,0 19.088,4.065 25.657,10.634c6.569,6.569 10.634,15.642 10.634,25.657l0,0.117c-0.007,2.151 -0.201,4.257 -0.567,6.303c-0.01,0.055 -0.02,0.111 -0.03,0.166c-0.065,0.354 -0.135,0.705 -0.21,1.055l-0.148,0.66l-0.245,0.981c-0.038,0.145 -0.077,0.289 -0.117,0.433c-1.029,3.706 -2.632,7.175 -4.707,10.305l-0.088,0.132c-0.524,0.782 -1.077,1.543 -1.659,2.281c-0.114,0.145 -0.228,0.288 -0.344,0.43l-0.597,0.716c-0.449,0.524 -0.912,1.035 -1.389,1.533l-0.533,0.544l0.005,0.005l-0.019,0.009c-5.859,5.852 -13.706,9.714 -22.436,10.481l-0.001,0c-1.058,0.092 -2.126,0.14 -3.206,0.14c-0.284,0 -0.568,-0.004 -0.85,-0.01c-2.307,0.049 -5.434,0.078 -8.94,0.01c-3.062,-0.06 -7.007,0.892 -8.444,1.269c-12.098,3.238 -22.91,9.62 -31.51,18.219l-0.201,0.202Z",
    style: {
      fill: "#0e98fa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.281,
    cy: 61.261,
    r: 15.005,
    style: {
      fill: "#0e98fa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 369.918,
    cy: 171.799,
    r: 15.005,
    style: {
      fill: "#0e98fa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.154,
    cy: 47.157,
    r: 15.005,
    style: {
      fill: "#0e98fa"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 166.481,
    cy: 213.96,
    r: 15.005,
    style: {
      fill: "#0e98fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.744,120.397c-4.521,-6.897 -6.271,-15.583 -4.137,-24.211c4.07,-16.452 20.731,-26.505 37.184,-22.436l0.186,0.047l0.187,0.046c16.451,4.075 26.498,20.74 22.422,37.191c-2.059,8.314 -7.335,14.993 -14.174,19.04c-16.48,7.588 -27.933,24.257 -27.933,43.579c0,11.145 3.81,21.407 10.199,29.555c3.963,6.69 5.405,14.879 3.392,23.017c-4.069,16.452 -20.731,26.505 -37.183,22.435l-0.187,-0.047l-0.187,-0.045c-16.45,-4.076 -26.497,-20.741 -22.422,-37.191c2.101,-8.481 7.548,-15.26 14.585,-19.278c16.182,-7.708 27.377,-24.217 27.377,-43.319c0,-10.618 -3.459,-20.435 -9.309,-28.383Z",
    style: {
      fill: "#0e98fa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M267.515,202.001l0,19.53c0,18.114 -14.685,32.798 -32.799,32.798c-18.114,0 -32.798,-14.684 -32.798,-32.798l0,-78.866c0,-30.835 24.997,-55.833 55.832,-55.833c30.835,0 55.832,24.998 55.832,55.833c0,25.587 -17.213,47.155 -40.692,53.755l0,0c-1.583,0.482 -2.792,0.765 -3.8,1.772c-1.008,1.008 -1.575,2.384 -1.575,3.809Z",
    style: {
      fill: "#0e98fa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.891,337.024c0,-10.058 -6.31,-17.748 -16.564,-17.748c-11.044,0 -17.354,7.887 -17.354,17.748c0,9.86 6.31,17.649 17.354,17.649c10.254,0 16.564,-7.592 16.564,-17.649m9.17,0c0,13.115 -9.269,26.228 -24.847,26.228c-8.677,0 -14.495,-3.55 -18.241,-8.283l0,26.031l-8.973,0l0,-69.021l8.973,0l0,7.001c3.746,-4.635 9.564,-8.184 18.241,-8.184c15.578,0 24.847,13.114 24.847,26.228",
    style: {
      fill: "#3f3e3e",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.502,311.98l0,49.99l-8.973,0l0,-6.901c-2.957,4.436 -7.888,8.183 -15.382,8.183c-11.24,0 -19.227,-9.367 -19.227,-19.917l0,-31.355l8.973,0l0,28.693c0,7.099 2.958,14 12.325,14c9.466,0 13.311,-8.085 13.311,-14l0,-28.693l8.973,0Z",
    style: {
      fill: "#3f3e3e",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.618,346.983c0,8.874 -6.311,16.269 -19.621,16.269c-9.86,0 -18.144,-3.944 -20.115,-11.438l8.776,-2.958c0.789,2.563 3.45,6.113 11.536,6.113c6.508,0 10.156,-2.662 10.156,-7.098c0,-5.819 -8.382,-5.819 -15.284,-7.396c-9.366,-2.07 -13.41,-6.606 -13.41,-14.002c0,-9.169 7.594,-15.677 18.439,-15.677c8.086,0 15.283,4.142 17.059,11.537l-8.382,2.267c-0.887,-2.76 -3.846,-5.719 -9.465,-5.719c-4.931,0 -8.579,2.762 -8.579,6.903c0,5.62 6.902,6.014 12.621,7.197c12.227,2.564 16.269,6.509 16.269,14.002",
    style: {
      fill: "#3f3e3e",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.665,330.714l0,31.256l-9.072,0l0,-28.693c0,-7.001 -2.958,-14.001 -12.325,-14.001c-9.465,0 -13.31,8.184 -13.31,14.001l0,28.693l-8.974,0l0,-69.021l8.974,0l0,26.031c2.958,-4.438 7.887,-8.184 15.479,-8.184c11.241,0 19.228,9.367 19.228,19.918",
    style: {
      fill: "#3f3e3e",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.992,311.98l9.86,0l0,14.987l-9.86,0l0,35.003l-17.749,0l0,-35.003l-6.211,0l0,-14.987l6.211,0c0,-9.269 2.662,-22.186 19.819,-22.186c3.353,0 5.916,0.493 7.79,0.79l0,14.494c-0.691,-0.1 -1.775,-0.197 -2.959,-0.197c-5.127,0 -6.901,3.056 -6.901,7.099",
    style: {
      fill: "#0e98fa",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.546,311.98l0,49.99l-17.747,0l0,-5.324c-2.565,3.648 -6.804,6.606 -13.706,6.606c-15.579,0 -18.341,-12.621 -18.341,-19.917l0,-31.355l17.749,0l0,27.016c0,3.845 2.761,6.804 7.198,6.804c4.338,0 7.1,-2.959 7.1,-6.804l0,-27.016l17.747,0Z",
    style: {
      fill: "#0e98fa",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.705,346.49c0,10.55 -8.676,16.761 -23.367,16.761c-10.058,0 -20.313,-3.056 -22.384,-11.831l15.58,-4.832c0.493,1.874 2.169,4.141 6.606,4.141c3.353,0 5.127,-1.478 5.127,-3.549c0,-3.057 -4.239,-3.254 -10.057,-4.536c-9.663,-2.169 -15.677,-5.62 -15.677,-15.381c0,-10.453 9.761,-16.467 22.284,-16.467c8.578,0 17.551,4.141 19.72,12.621l-14.199,3.451c-0.69,-2.268 -2.465,-3.747 -5.423,-3.747c-3.155,0 -5.226,1.282 -5.226,3.648c0,3.057 4.536,3.452 8.48,4.241c12.621,2.662 18.536,6.31 18.536,15.48",
    style: {
      fill: "#0e98fa",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.114,311.979l17.748,0l0,49.991l-17.748,0l0,-49.991Zm-0.394,-14.001c0,-5.029 4.141,-9.169 9.268,-9.169c5.127,0 9.269,4.14 9.269,9.169c0,5.128 -4.142,9.269 -9.269,9.269c-5.127,0 -9.268,-4.141 -9.268,-9.269",
    style: {
      fill: "#0e98fa",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.457,337.024c0,-5.521 -3.746,-8.972 -8.874,-8.972c-5.127,0 -8.973,3.451 -8.973,8.972c0,5.521 3.846,8.874 8.973,8.874c5.128,0 8.874,-3.353 8.874,-8.874m17.946,0c0,15.283 -11.241,26.228 -26.82,26.228c-15.579,0 -26.82,-10.945 -26.82,-26.228c0,-15.282 11.241,-26.228 26.82,-26.228c15.579,0 26.82,10.946 26.82,26.228",
    style: {
      fill: "#0e98fa",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500,330.714l0,31.256l-17.748,0l0,-26.918c0,-3.944 -2.761,-6.803 -7.1,-6.803c-4.338,0 -7.099,2.859 -7.099,6.803l0,26.918l-17.748,0l0,-49.99l17.748,0l0,5.324c2.564,-3.549 6.804,-6.508 13.607,-6.508c15.678,0 18.34,12.621 18.34,19.918",
    style: {
      fill: "#0e98fa",
      fillRule: "nonzero"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoPushFusion);
export default __webpack_public_path__ + "static/media/logoPushFusion.6b6c3c4011ad687e6b418238dedeebc5.svg";
export { ForwardRef as ReactComponent };